export default __webpack_public_path__ + "static/media/first-quarter.4e4a77a5.svg";